import EggsProduct from 'models/EggsProduct'

export const packagingInitialState = {
  category: EggsProduct.category,
  subCategory: EggsProduct.subCategory,
  Grade: {
    value: '',
    label: 'Grade',
  },
  ContainerSize: EggsProduct.containerSize,
}

export const eggGradeOptions = [
  {
    value: '',
    label: 'Grade',
    isDisabled: true,
  },
  {
    value: 'A',
    label: 'A',
  },
  {
    value: 'AA',
    label: 'AA',
  },
]
